import styled from 'styled-components';
import { PeopleListingGrid } from '../PeopleListing.style';

export const ReplacementWrapper = styled.div`
  color: var(--base-color-darkgrey);
`;

export const CreditListingWrapper = styled(PeopleListingGrid)`
  p {
    line-height: 1.5;
  }
`;

export const DescriptionWrapper = styled.div`
  color: var(--base-color-darkgrey);
  p {
    line-height: 25px;
    margin-bottom: 3px;
  }
`;

export const RoleWrapper = styled.div`
  color: var(--base-color-darkgrey);
  overflow-wrap: break-word;
  min-height: 1.5em;
`;

export const CreditWrapper = styled.div`
  display: grid;
  grid-template-columns: 0px 1fr;
  grid-template-areas: 'headshot role-person';
  grid-column-gap: 10px;
`;
